"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bew_localization_1 = require("@skype/bew-localization");
const React = require("react");
const SyncTasks = require("synctasks");
const AriaContext_1 = require("../../contexts/AriaContext");
const BotsContext_1 = require("../../contexts/bots/BotsContext");
const UserContext_1 = require("../../contexts/UserContext");
const ErrorHelper_1 = require("../../helpers/ErrorHelper");
const LoggerHelper_1 = require("../../helpers/LoggerHelper");
const BotsRestClient_1 = require("../../rest/BotsRestClient");
const ARootView_1 = require("../common/ARootView");
const StackNavigationView_1 = require("../common/StackNavigationView");
const AddBotView_1 = require("./AddBotView");
class RootView extends ARootView_1.ARootView {
    constructor() {
        super(...arguments);
        this.state = { isAddBotInProgress: false };
        this.handleAddBotViewProgress = () => this.setState({ isAddBotInProgress: true });
        this.handleAddBotViewAdd = () => this.setState((state) => ({ context: { ...state.context, isAddedAsContact: true }, isAddBotInProgress: false }));
        this.handleAddBotViewError = (error) => this.setState({ error, isAddBotInProgress: false });
        this._isLoading = (userContext) => {
            return this.props.loading || !(this.state.context && this.state.context.botInfo) || userContext.isLoginInProgress || this.state.isAddBotInProgress;
        };
    }
    componentDidMount() {
        const botId = this._getBotIdFromUrl();
        if (!botId) {
            throw ErrorHelper_1.displayableErrors.BotNotFound;
        }
        LoggerHelper_1.logger.initCommonProperty({ key: LoggerHelper_1.CommonProperty.BotId, value: botId });
        this._getBotInfo(botId)
            .then((botInfo) => {
            const context = { botId, botInfo, isAddedAsContact: false };
            this.setState({ context });
        }).catch((error) => {
            this.setState({
                error,
            });
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.loading && !this.props.loading) {
            document.title = bew_localization_1.localizer.getString('add_bot_to_contacts');
        }
    }
    render() {
        if (this.state.error) {
            throw this.state.error;
        }
        return React.createElement(BotsContext_1.BotsContextProvider, { value: this.state.context },
            React.createElement(UserContext_1.UserContextConsumer, null, (userContext) => React.createElement(AriaContext_1.AriaContextConsumer, null, (ariaContext) => React.createElement(StackNavigationView_1.StackNavigationView, { ariaContext: ariaContext, loading: this._isLoading(userContext), initialView: (React.createElement(AddBotView_1.AddBotView, { skypetoken: this.props.skypetoken, onProgress: this.handleAddBotViewProgress, onAdd: this.handleAddBotViewAdd, onError: this.handleAddBotViewError })), initialViewProps: { eventViewName: 'add-bot-view' } }))));
    }
    _getBotInfo(botId) {
        return BotsRestClient_1.default.getBotInfo(botId)
            .catch((response) => {
            const error = ErrorHelper_1.ErrorHelper.enrichErrorFromWebResponse(ErrorHelper_1.displayableErrors.BotNotFound, response, 'Get bot info');
            return SyncTasks.Rejected(error);
        });
    }
    _getBotIdFromUrl() {
        const pathName = window.location.pathname.replace(/\/+$/, '');
        const pathParts = pathName.split('/');
        return pathParts.pop();
    }
}
exports.RootView = RootView;
